import * as React from 'react';
import style from './CallbacksTableDisplay.scss';
import { getName } from '../../../../../../utils/treeVisitors/helpers';
import { StoreContext } from '../../../../../appContext/StoreProvider';
import { PARAM_TYPES } from '../../../../../../utils/treeVisitors/markCallbacksVisitor/types';
import { JSParamTable } from '../JSParamTable';
import { Anchor } from '../../../../Anchor';
import { getMdHeadingId } from '../../../../../../utils/locationUtils';
import { getCallbackIfNeeded } from '../../../NestedTable/NestedTableTypeDisplay/utils';

export const isCallback = (param) =>
  param.metaData && param.metaData.type === PARAM_TYPES.FUNCTION;

export const CallbacksTableContainer = ({ operation, path, prefix }) => {
  const { store } = React.useContext(StoreContext);

  const callbacks = operation.params
    .map((param) => getCallbackIfNeeded(param.type, param.metaData, store))
    .filter((callbackOrNull) => !!callbackOrNull);

  return callbacks.map((cb, i) => {
    const id = getMdHeadingId(path, cb.urlFormat);
    return (
      <React.Fragment key={`cb__${getName(cb)}__${i}`}>
        <Anchor id={id} />
        <div
          data-hook="callbacks-nested-table-wrapper"
          className={style.callbacksTable}
        >
          <JSParamTable operation={cb} prefix={prefix} />
        </div>
      </React.Fragment>
    );
  });
};
